// Google tag (gtag.js) is loaded in public/index.html with send_page_view:false,
// so this SPA controls page views and conversion events explicitly.

export function initAnalytics() {
  // No-op: gtag is initialised in index.html.
}

export function pageview(path) {
  if (typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function track(event, params = {}) {
  if (typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", event, params);
}
